/**
 * The product code a procedure template row should show, or null for none
 * (z8nrz7dp73).
 *
 * A product code describes a product; most templates never carry one. So an
 * absent code — and a present one that is empty or only whitespace — is simply
 * not shown, rather than printed as "No product code" on every row.
 * Display-only: the code itself is still stored, returned and editable.
 */
export function templateProductCode(template: { productCode?: string | null }): string | null {
  const code = template.productCode?.trim()
  return code ? code : null
}
